// Next Diamonds - Delivery Estimator
// Custom country dropdown (no native select), ZIP-based US tax (NY only),
// country-based import-tax estimate for non-US.

(function () {
  'use strict';

  var ZIP_PREFIX_TO_STATE = {
    '00':'PR', '01':'MA', '02':'MA', '03':'NH', '04':'ME',
    '05':'VT', '06':'CT', '07':'NJ', '08':'NJ', '09':'AE',
    '10':'NY', '11':'NY', '12':'NY', '13':'NY', '14':'NY',
    '15':'PA', '16':'PA', '17':'PA', '18':'PA', '19':'PA',
    '20':'DC', '21':'MD', '22':'VA', '23':'VA', '24':'VA',
    '25':'WV', '26':'WV',
    '27':'NC', '28':'NC',
    '29':'SC',
    '30':'GA', '31':'GA', '32':'FL', '33':'FL', '34':'FL',
    '35':'AL', '36':'AL', '37':'TN', '38':'TN',
    '39':'MS',
    '40':'KY', '41':'KY', '42':'KY',
    '43':'OH', '44':'OH', '45':'OH',
    '46':'IN', '47':'IN',
    '48':'MI', '49':'MI',
    '50':'IA', '51':'IA', '52':'IA',
    '53':'WI', '54':'WI',
    '55':'MN', '56':'MN',
    '57':'SD',
    '58':'ND',
    '59':'MT',
    '60':'IL', '61':'IL', '62':'IL',
    '63':'MO', '64':'MO', '65':'MO',
    '66':'KS', '67':'KS',
    '68':'NE', '69':'NE',
    '70':'LA', '71':'LA',
    '72':'AR', '73':'OK', '74':'OK',
    '75':'TX', '76':'TX', '77':'TX', '78':'TX', '79':'TX',
    '80':'CO', '81':'CO',
    '82':'WY', '83':'ID', '84':'UT',
    '85':'AZ', '86':'AZ',
    '87':'NM', '88':'NM',
    '89':'NV',
    '90':'CA', '91':'CA', '92':'CA', '93':'CA', '94':'CA', '95':'CA', '96':'CA',
    '97':'OR',
    '98':'WA', '99':'WA'
  };

  // Approximate import-tax estimates collected by the carrier on delivery.
  // These are reasonable industry averages for jewelry imported from the US.
  // They vary by item value, province, country, and HS code.
  var IMPORT_TAX = {
    CA: 'Approx. 13% import tax collected on delivery',
    UK: 'Approx. 22% VAT collected on delivery',
    EU: 'Approx. 22% VAT collected on delivery',
    AU: 'Approx. 10% GST collected on delivery',
    OTHER: 'Import duties may apply at destination'
  };

  function getStateFromZip(zip) {
    if (!/^\d{5}$/.test(zip)) return null;
    return ZIP_PREFIX_TO_STATE[zip.substring(0, 2)] || null;
  }

  function init() {
    // Support multiple instances on the same page (e.g. PDP + cart drawer).
    var wraps = document.querySelectorAll('.nd-delivery');
    if (!wraps.length) return;
    wraps.forEach(function (w) {
      if (!w.__ndDeliveryInit) {
        w.__ndDeliveryInit = true;
        initOne(w);
      }
    });
  }

  function initOne(wrap) {
    var dateEl = wrap.querySelector('[data-nd-delivery-date]');
    var cdd = wrap.querySelector('[data-nd-country-cdd]');
    var btn = wrap.querySelector('[data-nd-cdd-btn]');
    var panel = wrap.querySelector('[data-nd-cdd-panel]');
    var labelEl = wrap.querySelector('[data-nd-cdd-label]');
    var options = wrap.querySelectorAll('.nd-cdd__option');
    var zipWrap = wrap.querySelector('[data-nd-zip-wrap]');
    var zipEl = wrap.querySelector('[data-nd-delivery-zip]');
    var taxEl = wrap.querySelector('[data-nd-delivery-tax]');
    var productionDays = parseInt(wrap.getAttribute('data-production-days'), 10) || 10;
    var defaultCountry = wrap.getAttribute('data-default-country') || 'US';

    var current = { value: defaultCountry, transitDays: 2, label: 'United States' };

    function setCountry(value) {
      var found = null;
      options.forEach(function (opt) {
        if (opt.getAttribute('data-value') === value) found = opt;
      });
      if (!found) return;
      current.value = value;
      current.transitDays = parseInt(found.getAttribute('data-transit-days'), 10) || 3;
      current.label = found.textContent.trim();
      labelEl.textContent = current.label;
      options.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt === found);
      });
      updateAll();
    }

    function openPanel() {
      panel.hidden = false;
      cdd.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function closePanel() {
      panel.hidden = true;
      cdd.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function togglePanel() {
      if (panel.hidden) openPanel(); else closePanel();
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePanel();
    });
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        setCountry(opt.getAttribute('data-value'));
        closePanel();
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setCountry(opt.getAttribute('data-value'));
          closePanel();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!cdd.contains(e.target)) closePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    function addBusinessDays(start, days) {
      var d = new Date(start.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      return d;
    }
    function formatDate(d) {
      var wd = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()];
      var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];
      return wd + ', ' + mo + ' ' + d.getDate();
    }

    function updateDate() {
      var arrival = addBusinessDays(new Date(), productionDays + current.transitDays);
      dateEl.textContent = formatDate(arrival);
    }

    function updateTax() {
      taxEl.classList.remove('nd-delivery__tax--has-tax');
      if (current.value === 'US') {
        if (zipWrap) zipWrap.style.display = '';
        var zip = zipEl ? zipEl.value.trim() : '';
        if (zip.length === 5) {
          var state = getStateFromZip(zip);
          if (state === 'NY') {
            taxEl.textContent = '+8.875% NY tax at checkout';
            taxEl.classList.add('nd-delivery__tax--has-tax');
          } else if (state) {
            taxEl.textContent = state + ' \u00b7 \u2713 No sales tax collected';
          } else {
            taxEl.textContent = '\u2713 No sales tax collected';
          }
        } else {
          taxEl.textContent = '\u2713 No sales tax collected outside NY';
        }
      } else {
        if (zipWrap) zipWrap.style.display = 'none';
        taxEl.textContent = IMPORT_TAX[current.value] || IMPORT_TAX.OTHER;
      }
    }

    function updateAll() {
      updateDate();
      updateTax();
    }

    // Initial country detection
    var initialCountry = defaultCountry;
    try {
      var locale = (navigator.language || 'en-US').toUpperCase();
      var localeCountry = locale.split('-')[1] || '';
      if (localeCountry === 'GB') localeCountry = 'UK';
      var supported = ['US','CA','UK','AU'];
      if (supported.indexOf(localeCountry) > -1) {
        initialCountry = localeCountry;
      } else {
        var euLocales = ['DE','FR','IT','ES','NL','BE','SE','NO','DK','FI','PT','IE','PL','AT','CH','CZ','GR','HU','RO'];
        if (euLocales.indexOf(localeCountry) > -1) {
          initialCountry = 'EU';
        }
      }
    } catch (e) {}

    setCountry(initialCountry);

    if (zipEl) {
      zipEl.addEventListener('input', updateTax);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
